"use client";

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef } from "react";
import { LABEL_CSS, LABEL_GEOMETRY, MedicationLabelData, buildLabelContentHtml, fitLabelFont } from "@/lib/medication-label";
const DPI = 96;
/** Default on-screen magnification so the tiny label is readable. */
const DEFAULT_SCALE = 2.4;
interface LabelPreviewProps {
  data: MedicationLabelData;
  /** On-screen magnification. Lower it to fit a side-by-side column. */
  scale?: number;
}

/**
 * Renders the label at its exact physical size and runs the same auto-fit as
 * the print output, then visually scales it up. Measuring happens on the
 * unscaled element so the fitted size matches what actually prints.
 */
export default function LabelPreview(t0) {
  const $ = _c(19);
  const {
    data,
    scale: t1
  } = t0;
  const scale = t1 === undefined ? DEFAULT_SCALE : t1;
  const contentRef = useRef(null);
  let t2;
  if ($[0] !== data) {
    t2 = buildLabelContentHtml(data);
    $[0] = data;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const html = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const el = contentRef.current;
      if (!el) {
        return;
      }
      const availableHeightPx = (LABEL_GEOMETRY.heightIn - LABEL_GEOMETRY.padTopIn - LABEL_GEOMETRY.padBottomIn) * DPI;
      const availableWidthPx = (LABEL_GEOMETRY.widthIn - LABEL_GEOMETRY.padXIn * 2) * DPI;
      fitLabelFont(el, availableHeightPx, availableWidthPx);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== html) {
    t4 = [html];
    $[3] = html;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useLayoutEffect(t3, t4);
  const widthPx = LABEL_GEOMETRY.widthIn * DPI;
  const heightPx = LABEL_GEOMETRY.heightIn * DPI;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <style>{LABEL_CSS}</style>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = widthPx * scale;
  const t7 = heightPx * scale;
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = {
      width: t6,
      height: t7
    };
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = `scale(${scale})`;
  let t10;
  if ($[9] !== t9) {
    t10 = {
      transform: t9,
      transformOrigin: "top left",
      width: widthPx,
      height: heightPx
    };
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== html) {
    t11 = <div className="dymo-label"><div className="content" ref={contentRef} dangerouslySetInnerHTML={{
        __html: html
      }} /></div>;
    $[11] = html;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t10 || $[14] !== t11) {
    t12 = <div style={t10}>{t11}</div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t8) {
    t13 = <>{t5}<div className="overflow-hidden rounded-md shadow-md ring-1 ring-border" style={t8}>{t12}</div></>;
    $[16] = t12;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  return t13;
}